import { useRef, useEffect } from "react"

import React from "react"

import { Box, Button, Card, CardMedia, Typography } from "@mui/material"
import { flexCenterR, flexCenterC, flexSpaceR } from "../Styles/EvaluationToolTheme"
import { evaluationStageType } from "../Models/EvaluationStageType"
import { AnswersType } from "../Models/AnswersType"

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeIcon from '@mui/icons-material/Home';

import { useIsSmallScreen } from "../../../hooks/useIsSmallScreen"
import { PolyglotContext } from "../../../polyglot/polyGlotContext"
import { useContext } from "react"

interface EndContentBoxProps {
    imageA: string
    imageAltA: string
    buttonText: string;
    buttonAction: () => void;
    evaluationStage: evaluationStageType;
    setPageToStart: () => void;
    collectedAnswers: AnswersType;
    setCollectedAnswersCopy: React.Dispatch<React.SetStateAction<AnswersType>>;
    collectedAnswersCopy: AnswersType;
    setCollectedAnswers: React.Dispatch<React.SetStateAction<AnswersType>>;
    setPageToQuestionX: () => void;
}

const cardStyles = {
    height: "100%",
    mx: 8,
    boxShadow: "none",
}

const cardMediaStyles = {
    height: "100%",
    width: "auto",
    objectFit: "cover",
}

const EndContentBox: React.FC<EndContentBoxProps> = ({
    imageA,
    imageAltA,
    buttonText,
    buttonAction,
    evaluationStage,
    setPageToStart,
    collectedAnswers,
    setCollectedAnswersCopy,
    collectedAnswersCopy,
    setCollectedAnswers,
    setPageToQuestionX
}) => {
    const { polyglot } = useContext(PolyglotContext)

    const isSmallScreen = useIsSmallScreen()

    //Handles Page redirection together with handleForward(),
    //To ensure redirection does not happen before state update.
    //Look for better solution?
    const hasUpdated = useRef(false)
    useEffect(() => {
        if (hasUpdated.current === true) {
            setPageToStart();
        }
        hasUpdated.current = false
    }, [collectedAnswers])

    //Handles forward Logic
    const isProcessing = useRef(false)
    const handleForward = () => {
        if (isProcessing.current) return
        isProcessing.current = true

        setCollectedAnswers({})
        hasUpdated.current = true
    }

    const handleChangeAnswer = () => {
        setCollectedAnswersCopy({});
        setPageToQuestionX();
    }

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    height: "100%",
                    ...flexCenterC,
                    position: "relative",
                }}
            >
                <Box
                    sx={{
                        ...flexCenterC,
                        margin: "auto",
                        ...(isSmallScreen && { mt: 8 }),
                    }}
                >
                    <Card
                        sx={{
                            ...cardStyles, mb: "2rem",
                        }}
                    >
                        <CardMedia
                            sx={{
                                ...cardMediaStyles,
                            }}
                            component="img"
                            alt={imageAltA}
                            image={imageA}
                        />
                    </Card>
                    <Typography variant="h1" color="initial" sx={{ fontSize: "2.5rem" }}>{polyglot.t("evaluationTool.evaluationEnd.h1")}</Typography>
                </Box>

                {
                    evaluationStage === "beforeFull" || evaluationStage === "afterFull" ? (
                        <>
                        </>
                    ) : (
                        <>
                            <Box
                                sx={{
                                    ...(isSmallScreen ? { ...flexCenterC, mt: 4, height: "25%" } : { ...flexCenterR, mt: 8, width: "75%", justifyContent: "space-evenly" }),
                                }}
                            >
                            </Box>

                        </>
                    )
                }
            </Box >
            < Box sx={{ width: "100%", ...flexSpaceR, }}>
                <Button
                    onClick={handleChangeAnswer}
                    variant="outlined"
                    color="secondary"
                    sx={{
                        borderRadius: "20px",
                        px: "1.25rem",
                        py: "0.66rem",
                    }}
                >
                    <ArrowBackIosIcon sx={{ fontSize: '2.75rem', }} />{polyglot.t("evaluationTool.evaluationEnd.backBtn")}
                </Button>
                <Button
                    onClick={() => {
                        handleForward()
                    }}
                    variant="outlined"
                    sx={{
                        borderRadius: "20px",
                        px: "1.25rem",
                        py: "0.66rem",
                        ...(isSmallScreen && { mt: 4 }),
                    }}
                >
                    {polyglot.t("evaluationTool.evaluationEnd.startBtn")}&nbsp;
                    <HomeIcon sx={{ fontSize: "2.5rem" }} />
                </Button>
            </Box>
        </>

    )
}

export default EndContentBox



